(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User.Personal",
                {
                    url: "/Personal",
                    component: "userPersonal",
                    resolve: {
                        genders: ["genders", function (genders) {
                            return genders;
                        }],
                        phoneNumberTypes: ["phoneNumberTypes", function (phoneNumberTypes) {
                            return phoneNumberTypes;
                        }],
                        emailAddressTypes: ["emailAddressTypes", function (emailAddressTypes) {
                            return emailAddressTypes;
                        }],
                        physicalAddressTypes: ["physicalAddressTypes", function (physicalAddressTypes) {
                            return physicalAddressTypes;
                        }],
                        states: ["_states", function (states) {
                            return states;
                        }]
                    },
                    data: {
                        pageTitle: "Personal"
                    },
                    onEnter: ["$state", "person", function ($state, person) {
                        if (!person) {
                            $state.go("Home.404");
                        }
                    }]
                });
        }
    ]);

    app.component("userPersonal",
        {
            templateUrl: "/App/Settings/Agency/User/Personal/personal-template.html",
            controller: userPersonalController,
            bindings: {
                currentUser: "<",
                user: "<",
                person: "<",
                genders: "<",
                phoneNumberTypes: "<",
                emailAddressTypes: "<",
                physicalAddressTypes: "<",
                states: "<",
                onProfilePictureUpdated: "&",
                onPrimaryEmailAddressUpdated: "&",
                onPrimaryPhoneNumberUpdated: "&"
            }
        });

    function userPersonalController($q, userApi, $mdDialog, personApi, _, responseStatus, _formPattern, FieldStatusesModel, moment) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    Dob: null
                },
                updateUser: updateUser,
                addContact: addContact,
                updatePrimaryContact: updatePrimaryContact,
                updateContact: updateContact,
                removeContact: removeContact,
                updatePerson: updatePerson,
                responseStatus: responseStatus,
                formPattern: _formPattern
            });

        $ctrl.$onInit = () => {
            $ctrl.personSavingStatus = new FieldStatusesModel($ctrl.person);
            $ctrl.userSavingStatus = new FieldStatusesModel({ Position: "" });
            $ctrl.ui.Dob = $ctrl.person.Dob ? moment($ctrl.person.Dob).format("L") : null;
            if (!$ctrl.person.LastFourSsn)
                $ctrl.ui.showFullSsn = true;

            const promises = [
                personApi.getPhoneNumbers($ctrl.person.Id),
                personApi.getEmailAddresses($ctrl.person.Id),
                personApi.getPhysicalAddresses($ctrl.person.Id)
            ];

            $ctrl.ui.loading = true;
            $q.all(promises).then(responses => {
                [$ctrl.phoneNumbers, $ctrl.emailAddresses, $ctrl.physicalAddresses] = responses;

                $ctrl.ui.loading = false;
            });
        };

        function updateUser() {
            $ctrl.userSavingStatus.findFieldStatusByName("Position").startSaving();
            return userApi.update($ctrl.user)
                .then(function () {
                    $ctrl.userSavingStatus.findFieldStatusByName("Position").succeed();
                    $ctrl.ui.saving = false;
                }).catch(function () {
                    $ctrl.userSavingStatus.findFieldStatusByName("Position").fail();
                });
        }

        function updatePerson(editedField) {
            $ctrl.personSavingStatus.findFieldStatusByName(editedField).startSaving();
            $ctrl.ui.saving = true;
            $ctrl.user.FirstName = $ctrl.person.FirstName;
            $ctrl.user.MiddleName = $ctrl.person.MiddleName;
            $ctrl.user.LastName = $ctrl.person.LastName;
            $ctrl.user.DisplayName = $ctrl.person.NickName;

            if ($ctrl.ui.Dob)
                $ctrl.person.Dob = new Date($ctrl.ui.Dob);

            if ($ctrl.currentUser.Id === $ctrl.user.Id) {
                $ctrl.currentUser.FirstName = $ctrl.person.FirstName;
                $ctrl.currentUser.MiddleName = $ctrl.person.MiddleName;
                $ctrl.currentUser.LastName = $ctrl.person.LastName;
                $ctrl.currentUser.DisplayName = $ctrl.person.NickName;
            }

            return personApi.update($ctrl.person)
                .then(function () {
                    return userApi.update($ctrl.user).then(function () {
                        $ctrl.personSavingStatus.findFieldStatusByName(editedField).succeed();
                        $ctrl.ui.saving = false;
                    }).catch(function () {
                        $ctrl.personSavingStatus.findFieldStatusByName(editedField).fail();
                    });
                }).catch(function () {
                    $ctrl.personSavingStatus.findFieldStatusByName(editedField).fail();
                });
        }

        //CONTACTS
        function addContact(list, obj) {
            if (!_.find(list, function (row) { return !row.Id; })) {
                list.push(obj);
            }
        }

        function updatePrimaryContact(obj, type) {
            obj.saving = true;

            //set type.Preferred to false
            var i;
            if (type === "PhoneNumber") {
                for (i = 0; i < $ctrl.phoneNumbers.length; i++) {
                    $ctrl.phoneNumbers[i].Preferred = false;
                }
            }
            if (type === "EmailAddress") {
                for (i = 0; i < $ctrl.emailAddresses.length; i++) {
                    $ctrl.emailAddresses[i].Preferred = false;
                }
            }
            if (type === "PhysicalAddress") {
                for (i = 0; i < $ctrl.physicalAddresses.length; i++) {
                    $ctrl.physicalAddresses[i].Preferred = false;
                }
            }

            personApi["updatePrimary" + type]($ctrl.person.Id, obj).then(function (response) {
                if (type === "EmailAddress") {
                    userApi.updateEmail($ctrl.user.Id, { Value: obj.Value, Type: obj.Type }).then(function () {
                        $ctrl.person["Primary" + type] = response;
                        $ctrl.person["Primary" + type + "Id"] = obj.Id;
                        obj.Preferred = true;
                        obj.saving = false;
                        obj["Edit" + type] = false;
                    });
                    $ctrl.onPrimaryEmailAddressUpdated({ email: obj });
                } else {
                    if (type === "PhoneNumber")
                        $ctrl.onPrimaryPhoneNumberUpdated({ phoneNum: obj });
                    $ctrl.person["Primary" + type] = response;
                    $ctrl.person["Primary" + type + "Id"] = obj.Id;
                    obj.Preferred = true;
                    obj.saving = false;
                    obj["Edit" + type] = false;
                }
            });
        }

        function updateContact(obj, type) {
            obj.saving = true;

            if (obj.Id) {
                // existing object
                personApi["update" + type]($ctrl.person.Id, obj).then(function () {
                    if (obj.Preferred) {
                        $ctrl.updatePrimaryContact(obj, type);
                    }
                    else {
                        obj.saving = false;
                        obj["Edit" + type] = false;
                    }
                });

            } else {
                // new object
                personApi["add" + type]($ctrl.person.Id, obj).then(function (newObj) {
                    obj.Id = newObj.Id;
                    if (obj.Preferred) {
                        $ctrl.updatePrimaryContact(obj, type);
                    }
                    else {
                        obj.saving = false;
                        obj["Edit" + type] = false;
                    }
                });
            }
        }

        function removeContact(obj, list, type) {
            var confirmDelete = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you wish to delete this information?",
                ariaLabel: "Confirm Delete",
                ok: "Delete",
                cancel: "Cancel",
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirmDelete)
                .then(function () {
                    var index = _.findIndex(list, function (row) { return row === obj; });
                    list.splice(index, 1);

                    if (obj.Id) {
                        if (obj.Id === $ctrl.person["Primary" + type + "Id"]) {
                            personApi["remove" + type]($ctrl.person.Id, obj).then(function () {
                                if (list.length > 0) {
                                    updatePrimaryContact(list[0], type);
                                    if (type === "PhoneNumber")
                                        $ctrl.onPrimaryPhoneNumberUpdated({ phoneNum: list[0] });
                                    else if (type === "EmailAddress")
                                        $ctrl.onPrimaryEmailAddressUpdated({ email: list[0] });
                                } else {
                                    $ctrl.person["Primary" + type] = null;
                                    $ctrl.person["Primary" + type + "Id"] = null;

                                    if (type === "PhoneNumber")
                                        $ctrl.onPrimaryPhoneNumberUpdated({ phoneNum: null });
                                    else if (type === "EmailAddress")
                                        $ctrl.onPrimaryEmailAddressUpdated({ email: null });
                                }
                            });
                        } else {
                            personApi["remove" + type]($ctrl.person.Id, obj);
                        }
                    }
                });
        }
    }

})(window.app, window.angular); //jshint ignore:line